module.exports = __webpack_public_path__ + "img/37_1.79db3d91.png";